export const jobApplicationStatus = {
  IN_REVIEW: 3,
  OFFERED_POSITION: 4,
};

export const jobApplicationEditStatus = {
  NA: 0,
  REQUESTED: 1,
  APPROVED: 2,
};
